import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { publicSearchSchema } from '../-models'

export const Route = createFileRoute('/_public/login/')({
  validateSearch: (search) => parse(publicSearchSchema, search)
})
